/**
 * Shared print-layout helper components used inside <PrintPortal>.
 * All use inline styles for reliable cross-browser print output.
 */

function PrintSection({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div style={{ marginBottom: '18px' }}>
      <h2
        style={{
          fontSize: '14px',
          fontWeight: 700,
          borderBottom: '1px solid #ddd',
          paddingBottom: '4px',
          marginBottom: '10px'
        }}
      >
        {title}
      </h2>
      {children}
    </div>
  );
}

function PrintGrid({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '10px 16px'
      }}
    >
      {children}
    </div>
  );
}

function PrintField({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <p style={{ fontSize: '10px', color: '#888', margin: '0 0 2px' }}>
        {label}
      </p>
      <p style={{ fontSize: '12px', fontWeight: 600, margin: 0 }}>{value}</p>
    </div>
  );
}

export { PrintSection, PrintGrid, PrintField };
